'use es6';

import { catchError } from 'rxjs/operators/catchError';
import { mergeMap } from 'rxjs/operators/mergeMap';
import { of } from 'rxjs/observable/of';
import { startWith } from 'rxjs/operators/startWith';
import { ARCHIVED_CONTENT } from '../actions/ActionTypes';
import { receiveContent, requestArchiveContent, requestedArchiveContentFailure, requestedArchiveContentSuccess } from '../actions/ContentActions';
import { closeModal } from '../actions/ModalActions';
export default ((action$, _, {
  ContentClient
}) => action$.ofType(ARCHIVED_CONTENT).pipe(mergeMap(({
  payload: {
    contentType,
    id
  }
}) => ContentClient.archiveContent(contentType, id).pipe(mergeMap(content => of(receiveContent(content), closeModal(), requestedArchiveContentSuccess(contentType))), catchError(error => of(requestedArchiveContentFailure(error, contentType))), startWith(requestArchiveContent())))));